import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { Loading, Error } from '@carvana/purchase-styles';
import {
  RedirectWithSearchParams,
  ErrorBoundary
} from '@carvana/purchase-helpers';

const RouterRoutes = ({
  children,
  isLoading,
  match: { path },
  error: { isError, message } = {}
}) => (
  <ErrorBoundary>
    {isLoading && <Loading />}

    {isError && <Error message={message} />}

    {!isLoading && !isError && (
      <Switch>
        {children}

        <Route render={() => <RedirectWithSearchParams to={path} />} />
      </Switch>
    )}
  </ErrorBoundary>
);

RouterRoutes.propTypes = {
  children: PropTypes.node.isRequired,
  match: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.shape({})
  ]),
  lazyLoadingText: PropTypes.string,
  isLoadingText: PropTypes.string
};

RouterRoutes.defaultProps = {
  isLoading: false,
  lazyLoadingText: null,
  isLoadingText: null,
  error: false
};

export default RouterRoutes;
